
export enum TempleteType {
    templeteOne = 1,
    templeteTwo = 2,
    templeteThree = 3,
    templeteFour = 4,
    templeteFive = 5,
    templeteSix = 6,
    templeteSeven = 7,
    templeteEight = 8,
    templeteNine= 9,
}